import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Chip,
  Avatar,
  LinearProgress,
  IconButton,
  Button,
  Badge,
  Fade,
  Container,
  alpha,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  AlertTitle,
  Divider,
  InputAdornment,
  Tabs,
  Tab,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
} from "@mui/material";
import {
  AttachMoney,
  CreditCard,
  AccountBalance,
  QrCode,
  Payment,
  Receipt,
  Download,
  Print,
  History,
  Schedule,
  CheckCircle,
  Error,
  Pending,
  ArrowUpward,
  TrendingUp,
  Favorite,
  Share,
  Notifications,
  CalendarToday,
  EventAvailable,
  Star,
  ChevronRight,
  TrendingDown,
  LocalLibrary,
  Brush,
  Science,
  MenuBook,
  SportsSoccer,
  MusicNote,
  Today,
  CloudUpload,
  Description,
  Add,
  Remove,
  Info,
  Lock,
  Security,
  Speed,
} from "@mui/icons-material";
import { keyframes } from "@mui/system";
import apiEndpoints from "../apiconfig";


const Fees = () => {
  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("upi");
  const [amount, setAmount] = useState("");
  const [notes, setNotes] = useState("");
  const [message, setMessage] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [paymentDialog, setPaymentDialog] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [student, setStudent] = useState(null);
  const [feeSummary, setFeeSummary] = useState(null);
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [feeStructure, setFeeStructure] = useState([]);
  const [paymentHistory, setPaymentHistory] = useState([]);


const [studentGuid, setStudentGuid] = useState(null);

useEffect(() => {
  const raw = localStorage.getItem("active_student");
  const guid = raw ? JSON.parse(raw).guid : null;
  setStudentGuid(guid);
}, []);

  useEffect(() => {
    // const student_guid = '84cc8943-019c-44bc-93be-88e98e1e800c';

    if (!studentGuid) {
      setError("Student not found");
      setLoading(false);
      return;
    }

    const fetchFees = async () => {
      try {
        const response = await fetch(
          `${apiEndpoints.fees}?student_guid=${studentGuid}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (data.status !== "success") {
          throw new Error("Failed to load fee data");
        }

        const { student_summary, pending_fees, fee_structure, transactions } =
          data;

        /* ======================
           STUDENT
        ====================== */
        setStudent({
          name: student_summary.student_name,
          class: student_summary.class_name,
          admissionNo: student_summary.admission_number,
          avatar: "https://cdn-icons-png.flaticon.com/512/4140/4140047.png",
        });

        /* ======================
           FEE SUMMARY
        ====================== */
        setFeeSummary({
          totalDue: Number(student_summary.total_fee_amount),
          paid: Number(student_summary.paid_amount),
          pending: Number(student_summary.due_amount),
          nextDueDate: student_summary.next_due_date,
          overdue: 0,
        });

        /* ======================
           PENDING FEES
        ====================== */
        setPendingInvoices(
          pending_fees.map((item) => ({
            id: item.request_id,
            dueDate: item.due_date,
            amount: Number(item.payable_amount),
            description: item.description,
            category: "Fee",
            status: item.status,
          }))
        );

        /* ======================
           FEE STRUCTURE
        ====================== */
        setFeeStructure(
          fee_structure.map((item) => ({
            category: item.fee_name,
            period: item.frequency,
            amount: Number(item.amount),
          }))
        );

        setPaymentHistory(
          transactions.map((t) => ({
            id: t.id,
            description: t.description,
            invoiceNo: t.invoice_no,
            date: t.payment_date,
            amount: Number(t.amount),
            method: t.payment_method,
            status: t.status,
          }))
        );

        setLoading(false);
      } catch (err) {
        console.error(err);
        setMessage("No Fees Details Available");
        setLoading(false);
      }
    };

    fetchFees();
  }, [studentGuid]);

  useEffect(() => {
    setStudent(null);
    setFeeSummary(null);
    setPendingInvoices([]);
    setFeeStructure([]);
    setPaymentHistory([]);
    setSelectedInvoice("");
    setAmount("");
    setMessage("");
    setError(null);
    setLoading(true);
  }, [studentGuid]);


  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleInvoiceSelect = (invoice) => {
    setSelectedInvoice(invoice.id);
    setAmount(invoice.amount.toString());
  };

const handlePayment = async () => {
  try {
    const res = await fetch(`${apiEndpoints.payFee}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        student_guid: studentGuid,
        request_id: selectedInvoice,
        amount: amount,
        payment_method: paymentMethod,
      }),
    });

    const data = await res.json();

    if (data.status === "success") {
      setPaymentDialog(true); // show success UI
    } else {
      alert("Payment failed");
    }
  } catch (err) {
    console.error(err);
    alert("Server error");
  }
};

  const handleCloseDialog = () => {
    setPaymentDialog(false);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFile(file);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(amount);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Paid":
        return "#4CAF50";
      case "Pending":
        return "#FFB300";
      case "Overdue":
        return "#F44336";
      default:
        return "#666";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Paid":
        return <CheckCircle sx={{ color: "#4CAF50" }} />;
      case "Pending":
        return <Pending sx={{ color: "#FFB300" }} />;
      case "Overdue":
        return <Error sx={{ color: "#F44336" }} />;
      default:
        return <Info sx={{ color: "#666" }} />;
    }
  };

  const paymentMethods = [
    { value: "upi", label: "UPI", icon: <QrCode /> },
    { value: "card", label: "Credit/Debit Card", icon: <CreditCard /> },
    { value: "netbanking", label: "Net Banking", icon: <AccountBalance /> },
    { value: "wallet", label: "Wallet", icon: <Payment /> },
  ];

  const processingFees = [
    { type: "Transaction Fee", amount: 15 },
    { type: "GST (18%)", amount: 0 },
    { type: "Convenience Fee", amount: 10 },
  ];

  const totalProcessingFee = processingFees.reduce(
    (sum, fee) => sum + fee.amount,
    0
  );
  const totalAmount = (parseInt(amount) || 0) + totalProcessingFee;

  // Show loading state
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <LinearProgress sx={{ width: "50%" }} />
      </Box>
    );
  }
  if (message) {
    return (
      <Box
        sx={{
          minHeight: "100vh", // full screen height
          display: "flex",
          alignItems: "center", // vertical center
          justifyContent: "center", // horizontal center
          textAlign: "center",
          color: "text.secondary",
          px: 2,
        }}
      >
        <Typography variant="h6" color="text.secondary">
          {message}
        </Typography>
      </Box>
    );
  }

  // Show error state
  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          {error}
        </Alert>
      </Box>
    );
  }

  // Don't render until data is loaded
  if (!student || !feeSummary) {
    return null;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundImage: `
          linear-gradient(rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.92)),
          url('https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1920')
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.1) 0%, transparent 50%)
          `,
          pointerEvents: "none",
        },
      }}
    >
      {/* Decorative elements */}
      <Box
        sx={{
          position: "absolute",
          top: 100,
          right: 100,
          width: 200,
          height: 200,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(120, 119, 198, 0.05) 0%, transparent 70%)",
          filter: "blur(40px)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 100,
          left: 100,
          width: 150,
          height: 150,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(255, 119, 198, 0.05) 0%, transparent 70%)",
          filter: "blur(30px)",
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
        {/* HEADER */}
        <Fade in timeout={800}>
          <Box sx={{ py: 4, px: { xs: 2, md: 4 } }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    color: "#333",
                    mb: 1,
                    fontSize: { xs: "1.75rem", md: "2.125rem" },
                  }}
                >
                Fee Payment Portal
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ color: "text.secondary", fontWeight: 400 }}
                >
                  Manage and pay school fees securely • {student.name} •{" "}
                  {student.class}
                </Typography>
              </Box>
              
            </Box>
          </Box>
        </Fade>

        {/* STUDENT SUMMARY */}
        <Fade in timeout={900}>
          <Paper
            elevation={0}
            sx={{
              mb: 4,
              mx: { xs: 2, md: 4 },
              p: { xs: 3, md: 4 },
              borderRadius: "20px",
              background: "rgba(255, 255, 255, 0.7)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              boxShadow: "0 8px 32px rgba(31, 38, 135, 0.1)",
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
                <Box sx={{ position: "relative", display: "inline-block" }}>
                  <Avatar
                    src={student.avatar}
                    sx={{
                      width: 100,
                      height: 100,
                      border: "4px solid white",
                      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                    }}
                  />
                  <Chip
                    label="Active"
                    size="small"
                    icon={<CheckCircle sx={{ fontSize: 14 }} />}
                    sx={{
                      position: "absolute",
                      bottom: 10,
                      right: -10,
                      bgcolor: "white",
                      color: "#4CAF50",
                      fontWeight: 600,
                      border: "1px solid rgba(76, 175, 80, 0.3)",
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={9}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 700, mb: 1, color: "#1a1a1a" }}
                    >
                      {student.name}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#666", mb: 2 }}>
                      {student.class} • Admission No: {student.admissionNo}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                      <Chip
                        label={`Due: ${formatCurrency(feeSummary.pending)}`}
                        color="warning"
                        size="small"
                        icon={<Schedule />}
                      />
                      <Chip
                        label={`Paid: ${formatCurrency(feeSummary.paid)}`}
                        color="success"
                        size="small"
                        icon={<CheckCircle />}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="body2" sx={{ color: "#666" }}>
                          Total Annual Fee:
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 600, color: "#1976D2" }}
                        >
                          {formatCurrency(feeSummary.totalDue)}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="body2" sx={{ color: "#666" }}>
                          Amount Paid:
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 600, color: "#4CAF50" }}
                        >
                          {formatCurrency(feeSummary.paid)}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="body2" sx={{ color: "#666" }}>
                          Balance Due:
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 600, color: "#FFB300" }}
                        >
                          {formatCurrency(feeSummary.pending)}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="body2" sx={{ color: "#666" }}>
                          Next Due Date:
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 600, color: "#F44336" }}
                        >
                          {new Date(feeSummary.nextDueDate).toLocaleDateString(
                            "en-IN",
                            {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Fade>

        {/* FEE OVERVIEW CARDS */}
        <Fade in timeout={1000}>
          <Grid container spacing={3} sx={{ mb: 4, px: { xs: 2, md: 4 } }}>
            <Grid item sx={{
                width: {
                  xs: "100%",
                  sm: "50%",
                  md: "50%",
                  lg: "25%",
                  xl: "25%",
                },
              }}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: "16px",
                  background: "rgba(255, 255, 255, 0.6)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.8)",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "12px",
                      bgcolor: alpha("#4CAF50", 0.1),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#4CAF50",
                    }}
                  >
                    <CheckCircle />
                  </Box>
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "#666", fontWeight: 500 }}
                    >
                      Amount Paid
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 700, color: "#1a1a1a" }}
                    >
                      {formatCurrency(feeSummary.paid)}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  variant="caption"
                  sx={{ color: "#888", display: "block" }}
                >
                  68% of total fees
                </Typography>
              </Paper>
            </Grid>

            <Grid item sx={{
                width: {
                  xs: "100%",
                  sm: "50%",
                  md: "50%",
                  lg: "25%",
                  xl: "25%",
                },
              }}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: "16px",
                  background: "rgba(255, 255, 255, 0.6)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.8)",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "12px",
                      bgcolor: alpha("#FFB300", 0.1),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#FFB300",
                    }}
                  >
                    <Schedule />
                  </Box>
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "#666", fontWeight: 500 }}
                    >
                      Balance Due
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 700, color: "#1a1a1a" }}
                    >
                      {formatCurrency(feeSummary.pending)}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  variant="caption"
                  sx={{ color: "#888", display: "block" }}
                >
                  Due by{" "}
                  {new Date(feeSummary.nextDueDate).toLocaleDateString(
                    "en-IN",
                    { day: "numeric", month: "short" }
                  )}
                </Typography>
              </Paper>
            </Grid>

            <Grid item sx={{
                width: {
                  xs: "100%",
                  sm: "50%",
                  md: "50%",
                  lg: "25%",
                  xl: "25%",
                },
              }}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: "16px",
                  background: "rgba(255, 255, 255, 0.6)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.8)",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "12px",
                      bgcolor: alpha("#F44336", 0.1),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#F44336",
                    }}
                  >
                    <Error />
                  </Box>
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "#666", fontWeight: 500 }}
                    >
                      Overdue
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 700, color: "#1a1a1a" }}
                    >
                      {formatCurrency(feeSummary.overdue)}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  variant="caption"
                  sx={{ color: "#888", display: "block" }}
                >
                  No overdue payments
                </Typography>
              </Paper>
            </Grid>

            <Grid item sx={{
                width: {
                  xs: "100%",
                  sm: "50%",
                  md: "50%",
                  lg: "25%",
                  xl: "25%",
                },
              }}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: "16px",
                  background: "rgba(255, 255, 255, 0.6)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.8)",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "12px",
                      bgcolor: alpha("#1976D2", 0.1),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#1976D2",
                    }}
                  >
                    <Receipt />
                  </Box>
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "#666", fontWeight: 500 }}
                    >
                      Pending Invoices
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 700, color: "#1a1a1a" }}
                    >
                      {pendingInvoices.length}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  variant="caption"
                  sx={{ color: "#888", display: "block" }}
                >
                  {pendingInvoices.length} invoices to pay
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Fade>

        {/* MAIN PAYMENT SECTION */}
        <Fade in timeout={1100}>
          <Grid container spacing={3} sx={{ mb: 4, px: { xs: 2, md: 4 } }}>
            {/* LEFT SIDE: PAYMENT FORM */}
            <Grid item xs={12} lg={7}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 3, md: 4 },
                  borderRadius: "20px",
                  background: "rgba(255, 255, 255, 0.7)",
                  backdropFilter: "blur(20px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  boxShadow: "0 8px 32px rgba(31, 38, 135, 0.1)",
                  height: "100%",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, mb: 3, color: "#1a1a1a" }}
                >
                  Make a Payment
                </Typography>

                {/* Invoice Selection */}
                <Box sx={{ mb: 4 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 2, color: "#333" }}
                  >
                    💳 Select Invoice
                  </Typography>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Select</TableCell>
                          <TableCell>Invoice</TableCell>
                          <TableCell>Description</TableCell>
                          <TableCell>Due Date</TableCell>
                          <TableCell align="right">Amount</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {pendingInvoices.map((invoice) => (
                          <TableRow
                            key={invoice.id}
                            hover
                            selected={selectedInvoice === invoice.id}
                            onClick={() => handleInvoiceSelect(invoice)}
                            sx={{
                              cursor: "pointer",
                              bgcolor:
                                selectedInvoice === invoice.id
                                  ? alpha("#1976D2", 0.05)
                                  : "transparent",
                              "&:hover": {
                                bgcolor: alpha("#1976D2", 0.08),
                              },
                            }}
                          >
                            <TableCell>
                              <Radio
                                checked={selectedInvoice === invoice.id}
                                onChange={() => handleInvoiceSelect(invoice)}
                                value={invoice.id}
                              />
                            </TableCell>
                            <TableCell>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500 }}
                              >
                                {invoice.id}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {invoice.description}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{ color: "#666" }}
                              >
                                {invoice.category}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {new Date(invoice.dueDate).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "numeric",
                                    month: "short",
                                  }
                                )}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 600 }}
                              >
                                {formatCurrency(invoice.amount)}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                {/* Amount Field */}
                <Box sx={{ mb: 4 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 2, color: "#333" }}
                  >
                    💰 Amount
                  </Typography>
                  <TextField
                    fullWidth
                    type="number"
                    label="Payment Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography sx={{ color: "#666" }}>₹</Typography>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button
                            size="small"
                            onClick={() =>
                              setAmount(feeSummary.pending.toString())
                            }
                            sx={{ textTransform: "none" }}
                          >
                            Pay Full Balance
                          </Button>
                        </InputAdornment>
                      ),
                    }}
                    helperText={`Maximum payable: ${formatCurrency(
                      feeSummary.pending
                    )}`}
                  />
                </Box>

                {/* Payment Method */}
                <Box sx={{ mb: 4 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 2, color: "#333" }}
                  >
                    🏦 Payment Method
                  </Typography>
                  <Grid container spacing={2}>
                    {paymentMethods.map((method) => (
                      <Grid item xs={6} sm={3} key={method.value}>
                        <Card
                          sx={{
                            cursor: "pointer",
                            height:"110px",
                            border:
                              paymentMethod === method.value
                                ? `2px solid ${alpha("#1976D2", 0.8)}`
                                : "1px solid rgba(0, 0, 0, 0.1)",
                            bgcolor:
                              paymentMethod === method.value
                                ? alpha("#1976D2", 0.05)
                                : "rgba(255, 255, 255, 0.5)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              bgcolor: alpha("#1976D2", 0.08),
                            },
                          }}
                          onClick={() => setPaymentMethod(method.value)}
                        >
                          <CardContent sx={{ textAlign: "center", p: 2 }}>
                            <Box
                              sx={{
                                width: 40,
                                height: 40,
                                borderRadius: "8px",
                                bgcolor:
                                  paymentMethod === method.value
                                    ? alpha("#1976D2", 0.1)
                                    : alpha("#666", 0.1),
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color:
                                  paymentMethod === method.value
                                    ? "#1976D2"
                                    : "#666",
                                mb: 1,
                                mx: "auto",
                              }}
                            >
                              {method.icon}
                            </Box>
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 500 }}
                            >
                              {method.label}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                {/* Notes & Receipt Upload */}
                <Box sx={{ mb: 4 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 2, color: "#333" }}
                  >
                    📝 Additional Information
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Notes (optional)"
                    placeholder="Add any notes for this payment..."
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />

                  <Box sx={{ mt: 2 }}>
                    <input
                      accept=".pdf,.jpg,.jpeg,.png"
                      style={{ display: "none" }}
                      id="receipt-upload"
                      type="file"
                      onChange={handleFileUpload}
                    />
                    <label htmlFor="receipt-upload">
                      <Button
                        component="span"
                        startIcon={<CloudUpload />}
                        variant="outlined"
                        sx={{ mt: 1 }}
                      >
                        Upload Receipt/Proof
                      </Button>
                    </label>
                    {uploadedFile && (
                      <Typography
                        variant="caption"
                        sx={{ display: "block", mt: 1, color: "#4CAF50" }}
                      >
                        ✓ {uploadedFile.name} uploaded
                      </Typography>
                    )}
                  </Box>
                </Box>

                {/* Payment Summary */}
                <Paper
                  sx={{
                    p: 3,
                    mb: 3,
                    borderRadius: "12px",
                    bgcolor: alpha("#1976D2", 0.05),
                    border: `1px solid ${alpha("#1976D2", 0.2)}`,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 2, color: "#1976D2" }}
                  >
                    Payment Summary
                  </Typography>
                  <List dense>
                    <ListItem>
                      <ListItemText primary="Invoice Amount" />
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {formatCurrency(parseInt(amount) || 0)}
                      </Typography>
                    </ListItem>
                    {processingFees.map((fee, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          primary={fee.type}
                          primaryTypographyProps={{
                            variant: "caption",
                            color: "text.secondary",
                          }}
                        />
                        <Typography variant="caption" sx={{ fontWeight: 600 }}>
                          {formatCurrency(fee.amount)}
                        </Typography>
                      </ListItem>
                    ))}
                    <Divider sx={{ my: 1 }} />
                    <ListItem>
                      <ListItemText
                        primary="Total Amount Payable"
                        primaryTypographyProps={{
                          variant: "subtitle2",
                          fontWeight: 600,
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: 700, color: "#1976D2" }}
                      >
                        {formatCurrency(totalAmount)}
                      </Typography>
                    </ListItem>
                  </List>
                </Paper>

                {/* Action Buttons */}
                <Box
                  sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}
                >
                  <Button
                    variant="outlined"
                    sx={{
                      borderRadius: "25px",
                      px: 4,
                      py: 1.5,
                    }}
                  >
                    Save as Draft
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handlePayment}
                    disabled={!amount || !selectedInvoice}
                    sx={{
                      borderRadius: "25px",
                      px: 4,
                      py: 1.5,
                      bgcolor: "#1976D2",
                      fontWeight: 600,
                      "&:hover": {
                        bgcolor: "#1565C0",
                      },
                      "&.Mui-disabled": {
                        bgcolor: alpha("#1976D2", 0.5),
                      },
                    }}
                  >
                    Proceed to Pay {formatCurrency(totalAmount)}
                  </Button>
                </Box>

                {/* Security Note */}
                <Alert
                  severity="info"
                  sx={{
                    mt: 3,
                    borderRadius: "12px",
                    bgcolor: alpha("#1976D2", 0.05),
                  }}
                  icon={<Security />}
                >
                  <AlertTitle>Secure Payment</AlertTitle>
                  All payments are processed through secure payment gateways
                  with 256-bit SSL encryption. Your financial information is
                  never stored on our servers.
                </Alert>
              </Paper>
            </Grid>

            {/* RIGHT SIDE: FEE STRUCTURE & HISTORY */}
            <Grid item xs={12} lg={5}>
              {/* Fee Structure */}
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  mb: 3,
                  borderRadius: "20px",
                  background: "rgba(255, 255, 255, 0.6)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  height: "49%",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, mb: 3, color: "#1a1a1a" }}
                >
                  Fee Structure
                </Typography>
                <List>
                  {feeStructure.map((item, index) => (
                    <React.Fragment key={index}>
                      <ListItem
                        sx={{
                          py: 1.5,
                          borderRadius: "8px",
                          "&:hover": {
                            bgcolor: "rgba(0, 0, 0, 0.02)",
                          },
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 500 }}
                            >
                              {item.category}
                            </Typography>
                          }
                          secondary={
                            <Typography
                              variant="caption"
                              sx={{ color: "#666" }}
                            >
                              {item.period}
                            </Typography>
                          }
                        />
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {formatCurrency(item.amount)}
                        </Typography>
                      </ListItem>
                      {index < feeStructure.length - 1 && <Divider />}
                    </React.Fragment>
                  ))}
                </List>

                {/* <Box sx={{ mt: 3, p: 2, bgcolor: alpha("#4CAF50", 0.05), borderRadius: "12px" }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: "#1a1a1a" }}>
                    💡 Payment Tips
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#666", display: "block" }}>
                    • Early payments receive 2% discount
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#666", display: "block" }}>
                    • Installment plans available
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#666", display: "block" }}>
                    • Save receipts for tax purposes
                  </Typography>
                </Box> */}
              </Paper>

              {/* Recent Payments */}
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: "20px",
                  background: "rgba(255, 255, 255, 0.6)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  height: "49%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: "#1a1a1a" }}
                  >
                    Recent Payments
                  </Typography>
                  <Button
                    endIcon={<ChevronRight />}
                    size="small"
                    sx={{ color: "#666", textTransform: "none" }}
                  >
                    View All
                  </Button>
                </Box>
                <Box sx={{ maxHeight: "100%", overflow: "auto", pr: 1 }}>
                  {paymentHistory.map((payment) => (
                    <Box
                      key={payment.id}
                      sx={{
                        p: 2,
                        mb: 2,
                        borderRadius: "12px",
                        bgcolor: "rgba(255, 255, 255, 0.5)",
                        borderLeft: `4px solid ${getStatusColor(
                          payment.status
                        )}`,
                        transition: "all 0.3s ease",
                        "&:hover": {
                          bgcolor: "white",
                          transform: "translateX(4px)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          mb: 1,
                        }}
                      >
                        <Box>
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 600, mb: 0.5 }}
                          >
                            {payment.description}
                          </Typography>
                          <Typography variant="caption" sx={{ color: "#666" }}>
                            {payment.invoiceNo} •{" "}
                            {new Date(payment.date).toLocaleDateString("en-IN")}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                          }}
                        >
                          {getStatusIcon(payment.status)}
                          <Typography
                            variant="caption"
                            sx={{
                              color: getStatusColor(payment.status),
                              fontWeight: 600,
                            }}
                          >
                            {payment.status}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="caption" sx={{ color: "#666" }}>
                          {payment.method}
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {formatCurrency(payment.amount)}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Fade>

        {/* PAYMENT SUCCESS DIALOG */}
        <Dialog
          open={paymentDialog}
          onClose={handleCloseDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: "12px",
                  bgcolor: alpha("#4CAF50", 0.1),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#4CAF50",
                }}
              >
                <CheckCircle fontSize="large" />
              </Box>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Payment Successful!
                </Typography>
                <Typography variant="caption" sx={{ color: "#666" }}>
                  Transaction ID: TXN-{Date.now().toString().slice(-8)}
                </Typography>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ textAlign: "center", py: 3 }}>
              <Typography
                variant="h4"
                sx={{ fontWeight: 700, color: "#4CAF50", mb: 1 }}
              >
                {formatCurrency(totalAmount)}
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", mb: 3 }}>
                Payment processed successfully
              </Typography>

              <Paper sx={{ p: 2, mb: 3, bgcolor: alpha("#4CAF50", 0.05) }}>
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
                  Payment Details
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography variant="caption" sx={{ color: "#666" }}>
                      Method:
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ display: "block", fontWeight: 500 }}
                    >
                      {
                        paymentMethods.find((m) => m.value === paymentMethod)
                          ?.label
                      }
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption" sx={{ color: "#666" }}>
                      Date:
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ display: "block", fontWeight: 500 }}
                    >
                      {new Date().toLocaleDateString("en-IN")}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption" sx={{ color: "#666" }}>
                      Invoice:
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ display: "block", fontWeight: 500 }}
                    >
                      {selectedInvoice}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption" sx={{ color: "#666" }}>
                      Status:
                    </Typography>
                    <Chip
                      label="Completed"
                      size="small"
                      sx={{
                        bgcolor: alpha("#4CAF50", 0.1),
                        color: "#4CAF50",
                        fontWeight: 500,
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Alert severity="success" sx={{ mb: 2 }}>
                A receipt has been sent to your registered email address.
              </Alert>
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 0 }}>
            <Button onClick={handleCloseDialog} sx={{ color: "#666" }}>
              Close
            </Button>
            <Button
              variant="contained"
              startIcon={<Download />}
              sx={{ bgcolor: "#1976D2" }}
            >
              Download Receipt
            </Button>
            <Button variant="outlined" startIcon={<Print />}>
              Print
            </Button>
          </DialogActions>
        </Dialog>

        {/* FOOTER */}
        <Fade in timeout={1200}>
          <Box sx={{ py: 4, textAlign: "center", px: { xs: 2, md: 4 } }}>
            <Typography variant="body2" sx={{ color: "#666", opacity: 0.8 }}>
              © 2025 My School • Fee payments are processed securely • For
              assistance, contact: fees@myschool.edu
            </Typography>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default Fees;
